import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Form, Input, Select, Button, DatePicker, Row, Col } from 'antd';
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/it_IT';
import 'moment/locale/it';
moment.locale('it', {
  months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
    '_',
  ),
  monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
  weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
    '_',
  ),
  weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
  weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
  week: {
    dow: 1,
    doy: 4,
  },
});
import { connect } from 'react-redux';
import { compose } from 'redux';
import messages from './messages';

import { createStructuredSelector } from 'reselect';

import { makeSelectQuotationsParameters, makeSelectQuotationsFilters } from 'containers/Quotations/selectors';
import { searchQuotations } from 'containers/Quotations/actions';
import { withQuotationReducer } from 'containers/Quotations/withReducer';

import 'antComponentsStyle';
import './styles.scss';

const dateFormat = 'YYYY-MM-DD';

class QuotationsSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.parameters,
      datePickerEndOpen: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps.parameters });
  }

  get canSearch() {
    return this.state.startDate && this.state.endDate;
  }

  handleOnChange = event => {
    const value = event.target.value;
    const name = event.target.name;

    this.setState({
      [name]: value,
    });
  };

  handleSelectChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    if (this.canSearch) {
      this.props.search(this.state);
    }
  };

  handleSetStatusFilter = ({ target, currentTarget }) => {
    let { status } = this.state;
    const { value } = target;

    status = Array.isArray(status) ? status : [];

    if (status.includes(value)) {
      status = status.filter(statusValue => statusValue !== value);
    } else {
      status.push(value);
    }

    currentTarget.blur();

    this.setState({ status }, () => this.props.search(this.state));
  };

  setStartDate = startDate =>
    this.setState({
      startDate: startDate.format('YYYY-MM-DD'),
    });

  setEndDate = endDate =>
    this.setState({
      endDate: endDate.format('YYYY-MM-DD'),
    }, () => this.props.search(this.state));

  handleStartOpenChange = open => {
    if (!open) {
      this.setState({ datePickerEndOpen: true });
    }
  };

  handleEndOpenChange = open => {
    this.setState({ datePickerEndOpen: open });
  };

  disabledStartDate = startValue => {
    let { endDate } = this.state;
    endDate = moment(endDate, dateFormat);

    if (!startValue || !endDate) {
      return false;
    }

    return startValue.valueOf() > endDate.valueOf();
  };

  disabledEndDate = endValue => {
    let { startDate } = this.state;
    startDate = moment(startDate, dateFormat);

    if (!endValue || !startDate) {
      return false;
    }

    return endValue.valueOf() <= startDate.valueOf();
  };

  render() {
    const {
      query,
      fiscal_code,
      quotation_id,
      startDate,
      endDate,
      datePickerEndOpen,
      status,
      agent_id,
    } = this.state;
    const { filters } = this.props;

    const dataRangeStartId = `quotations-data-range-start`;
    const dataRangeStartLabel = `Inizio data creazione preventivo`;

    const dataRangeEndId = `quotations-data-range-end`;
    const dataRangeEndLabel = `Fine data creazione preventivo`;

    const contactQueryId = `query`;
    const contactQueryLabel = `inserisci nome, cognome o ragione sociale`;

    const fiscalCodeId = `fiscal_code`;
    const fiscalCodeLabel = `Codice fiscale o partita iva`;

    const quotationNumberId = `quotation_number`;
    const quotationNumberLabel = `numero preventivo`;

    const quotationStatusId = `quotations-status`;
    const quotationStatusLabel = `Stato pratica:`;

    const agentsId = `agent-id`;
    const agentsLabel = `Agente`;

    return (
      <div id="QuotationsSearch">
        <h3 className="todo-sidebar-section-header">
          <FormattedMessage {...messages.title} />
        </h3>
        <Form layout="vertical" className="search" onSubmit={this.handleSubmit}>
          <Form.Item>
            <label htmlFor={dataRangeStartId} className="sr-only sr-only-focusable">
              {dataRangeStartLabel}
            </label>
            <Row gutter={16}>
              <Col xxl={12} xl={24}>
                <DatePicker
                  value={moment(startDate, dateFormat)}
                  format="DD MMMM YYYY"
                  locale={locale}
                  onChange={this.setStartDate}
                  onOpenChange={this.handleStartOpenChange}
                  disabledDate={this.disabledStartDate}
                  allowClear={false}
                  className="date-range-picker md-6"
                  id={dataRangeStartId}
                />
              </Col>
              <Col xxl={12} xl={24}>
                <label htmlFor={dataRangeEndId} className="sr-only sr-only-focusable">
                  {dataRangeEndLabel}
                </label>
                <DatePicker
                  defaultValue={moment(endDate, dateFormat)}
                  format="DD MMMM YYYY"
                  locale={locale}
                  onChange={this.setEndDate}
                  onOpenChange={this.handleEndOpenChange}
                  disabledDate={this.disabledEndDate}
                  allowClear={false}
                  open={datePickerEndOpen}
                  className="date-range-picker md-6"
                  id={dataRangeEndId}
                />
              </Col>
            </Row>
          </Form.Item>
          <Form.Item>
            <label
              htmlFor={contactQueryId}
              className="sr-only sr-only-focusable"
            >
              {contactQueryLabel}
            </label>
            <FormattedMessage {...messages.customer_field_placeholder}>
              {placeholder => (
                <Input
                  name="query"
                  id={contactQueryId}
                  autoComplete="off"
                  value={query}
                  placeholder={placeholder}
                  onChange={this.handleOnChange}
                />
              )}
            </FormattedMessage>
          </Form.Item>
          <Form.Item>
            <label htmlFor={fiscalCodeId} className="sr-only sr-only-focusable">
              {fiscalCodeLabel}
            </label>
            <FormattedMessage {...messages.fiscal_code_field_placeholder}>
              {placeholder => (
                <Input
                  name="fiscal_code"
                  id={fiscalCodeId}
                  value={fiscal_code}
                  placeholder={placeholder}
                  onChange={this.handleOnChange}
                />
              )}
            </FormattedMessage>
          </Form.Item>
          <Form.Item>
            <label
              htmlFor={quotationNumberId}
              className="sr-only sr-only-focusable"
            >
              {quotationNumberLabel}
            </label>
            <FormattedMessage {...messages.quotation_id_field_placeholder}>
              {placeholder => (
                <Input
                  name="quotation_id"
                  id={quotationNumberId}
                  value={quotation_id}
                  placeholder={placeholder}
                  onChange={this.handleOnChange}
                />
              )}
            </FormattedMessage>
          </Form.Item>

          <Form.Item>
            <label
              htmlFor={agentsId}
              className="sr-only sr-only-focusable"
            >
              {agentsLabel}
            </label>
            <FormattedMessage {...messages.agent_id_field_placeholder} />
            <Select name="agent_id" value={agent_id || ''} onChange={value => this.handleSelectChange('agent_id', value)} id={agentsId} allowClear>
              {/* <Select.Option value=""> </Select.Option> */}
              {filters && filters.agents && filters.agents.length
                && Object.values(filters.agents).map(agent => (
                    <Select.Option value={agent.value} key={agent.value}>
                      {agent.label}
                    </Select.Option>
                  ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <div className="ant-col ant-form-item-label">
              <label htmlFor={quotationStatusId}>{quotationStatusLabel}</label>
            </div>

            <Button.Group
              // onChange={this.handleSetStatusFilter}
              className="filter-status-buttons-container"
              id={quotationStatusId}
            >
              <QuotationStatusFilterButton
                value="WON"
                label="Vinto"
                statusFilter={status}
                onClick={this.handleSetStatusFilter}
              />
              <QuotationStatusFilterButton
                value="LOST"
                label="Perso"
                statusFilter={status}
                onClick={this.handleSetStatusFilter}
              />
              <QuotationStatusFilterButton
                value="OPEN"
                label="In corso"
                statusFilter={status}
                onClick={this.handleSetStatusFilter}
              />
            </Button.Group>
          </Form.Item>
          <Form.Item>
            <Button
              size="large"
              className="btn-primary"
              type="primary"
              disabled={!this.canSearch}
              onClick={this.handleSubmit}
              htmlType="submit"
            >
              <FormattedMessage {...messages.search} />
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const QuotationStatusFilterButton = ({
  value,
  label,
  statusFilter,
  onClick,
}) => (
  <Button
    value={value}
    type={statusFilter.includes(value) ? 'primary' : 'default'}
    onClick={onClick}
    className="filter-status-button"
  >
    {label}
  </Button>
);

QuotationsSearch.propTypes = {};

const mapStateToProps = createStructuredSelector({
  parameters: makeSelectQuotationsParameters(),
  filters: makeSelectQuotationsFilters(),
});

export function mapDispatchToProps(dispatch) {
  return {
    search: params => dispatch(searchQuotations(params)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withQuotationReducer,
  withConnect,
)(QuotationsSearch);
